/* tslint:disable */
import * as _ from "lodash";
import { getStoreAccessors } from "vuex-typescript";
import { setVuexKeys } from "@src/store/StoreHelper";
import * as WModals from "@proxy/Modals";
import ModalState = Modals.ModalState;

const ModalStore = {
    namespaced: true,
    state: new Array<Modals.ModalState<any>>(0),
    mutations: {
        show(state: Modals.ModalState<any>[], data: Modals.ModalState<any>): void {
            let queueItem: Modals.ModalState<any> = data;
            queueItem.id = _.random(1, 1000, false);
            queueItem.backdrop = data.backdrop ? data.backdrop : true;
            state.push(queueItem);
        },
        close(state: Modals.ModalState<any>[], modalId: number): void {
            let dialogs: Modals.ModalState<any>[] = state.filter((value) => {
                return value.id === modalId;
            });
            if (dialogs.length === 1) {
                let dialogIndex: number = state.indexOf(dialogs[0]);
                state.splice(dialogIndex, 1);
            }
        }
    },
    actions: {
        show(context: any, data: Modals.ModalState<any>): void {
            data.success = data.success ? data.success : () => {};
            context.commit("show", data);
        },
        close(context: any, modalId: number): void {
            context.commit("close", modalId);
        }
    }
};

export default ModalStore;
const { dispatch } = getStoreAccessors<ModalState<any>[], any>("modalStore");

const actions = setVuexKeys(ModalStore.actions);
export const show = dispatch(actions.show);
export const close = dispatch(actions.close);

export const WellknownModals = WModals;
